<template>
    <div>
        <router-view />

        <LaDialog name="websiteForm">
            <LaWebsiteForm />
        </LaDialog>
    </div>
</template>

<script>
import { computed } from "vue";
import LaDialog from "@/components/dialog/Dialog";
import LaWebsiteForm from "@/components/dialog/WebsiteForm";
import store from "@/store/store";
import { actionTypes as publisherActionTypes, getterTypes as publisherGetterTypes } from "@/store/Publisher/types";
import { actionTypes as adstxtActionTypes, getterTypes as adstxtGetterTypes } from "@/store/Adstxt/types";

export default {
    name: "LoggedView",
    components: {
        LaDialog,
        LaWebsiteForm,
    },
    setup() {
        const publishers = store.getters[publisherGetterTypes.getPublishers];
        if (!publishers || !publishers.length) {
            store.dispatch(publisherActionTypes.getData);
        }
        const adsTxtValidation = computed(() => store.getters[adstxtGetterTypes.getAdstxtValidationResult]);
        if (!adsTxtValidation.value || !adsTxtValidation.value.status) {
            store.dispatch(adstxtActionTypes.getValidationResult, {});
        }
    },
};
</script>
